import React from 'react';
import { GuideHero } from '../components/GuideHero';
import { StepNav } from '../components/StepNav';
import { GuideStepSection } from '../components/GuideStepSection';
import { CurrentInvestments } from '../components/CurrentInvestments';
import { NewsletterSection } from '../components/NewsletterSection';
import { HelpSection } from '../components/HelpSection';
import { guideSteps } from '../data/guideSteps';
interface InvestorGuideProps {
  screenshotTone: 'mono' | 'color';
  showStepNav: boolean;
  stepLayout: 'alternating' | 'aligned';
}
export function InvestorGuide({
  screenshotTone,
  showStepNav,
  stepLayout
}: InvestorGuideProps) {
  return <div className="min-h-screen w-full bg-canvas font-sans" data-id="element-128" data-mp="1qvsge6mbc7s7">
      <GuideHero data-id="element-129" data-mp="1m26084gxxlrn" />
      {showStepNav && <StepNav data-id="element-130" data-mp="1m0uxm7z8ek24" />}
      <main className="mx-auto w-full max-w-7xl px-6 lg:px-10" data-id="element-131" data-mp="yddawqutqc60">
        {guideSteps.map((step, index) => <GuideStepSection key={step.id} step={step} flip={stepLayout === 'alternating' && index % 2 === 1} mono={screenshotTone === 'mono'} data-id="element-132" data-mp="uc1hea8tx6sj" data-mpi={index} />)}
        <CurrentInvestments data-id="element-133" data-mp="jkxoadopqtay" />
        <NewsletterSection data-id="element-134" data-mp="jjuvu1bqsisx" />
        <HelpSection data-id="element-135" data-mp="jj2z2n6esf12" />
      </main>
    </div>;
}